import { AuthSelectors } from '@web_opxp/features';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { redirectToMedRecruitment } from '../base/historyService';
import Banner from './Banner';
import { onBannerClickTrackingAction, onBannerCloseTrackingAction } from './firebaseActions';
import { closeMedBanner } from './service';
import useMedBannerToggle from './useMedBannerToggle';
import { Dispatch, Action } from 'redux';

export default function MedBannerWrapper() {
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const [showMedBanner, toggleMedBanner] = useMedBannerToggle();
  const isPremium = useSelector(AuthSelectors.isPremium);

  const clickHandler = useCallback(() => {
    dispatch(onBannerClickTrackingAction(isPremium));
    redirectToMedRecruitment();
  }, [dispatch, isPremium]);

  const closeHandler = useCallback(() => {
    dispatch(onBannerCloseTrackingAction(isPremium));
    closeMedBanner();
    toggleMedBanner(false);
  }, [dispatch, isPremium, toggleMedBanner]);
  return <Banner show={showMedBanner} onClick={clickHandler} onClose={closeHandler} />;
}
